import { LabelHTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';

type PropsFromLabel = Pick<
    LabelHTMLAttributes<HTMLLabelElement>,
    'children' | 'id' | 'className' | 'style' | 'htmlFor'
>;
export type LabelProps = PropsFromLabel & {
    label: string | ReactNode;
    required?: boolean;
    as?: 'div';
};

const LabelContainer = styled.label`
    display: flex;
    flex-direction: column;
`;

export const LabelText = styled.span`
    font-size: 1.4rem;
    font-weight: 500;
`;

export const Asterisk = styled.sup`
    color: var(--error-default);
`;

export function Label({ label, as, required, children, ...rest }: LabelProps) {
    return (
        <LabelContainer as={as} {...rest}>
            <LabelText>
                {label}
                {required ? (
                    <>
                        &nbsp;
                        <Asterisk>*</Asterisk>
                    </>
                ) : (
                    ''
                )}
            </LabelText>
            {children}
        </LabelContainer>
    );
}
